import { create } from 'zustand'
import { createGanttChartSlice, IGanttChartSlice } from './Slices/GanttChartSlice'
import { createProjectSlice, IProjectSlice } from './Slices/ProjectSlice'

export const useProjectGanttChartStore = create<IGanttChartSlice & IProjectSlice>((...a) => ({
  ...createGanttChartSlice(...a),
  ...createProjectSlice(...a),
}))
